import moment from "moment";
import "moment-timezone";
import React from "react";
import { connect, ConnectedProps } from "react-redux";

import errorWhiteSvg from "assets/img/error-white.svg";
import { Body } from "components/Typography";
import { State } from "state";
import { unsetError, FileUploadState } from "state/create_file_upload";
import { fetchStoresByProjectId } from "state/stores";
import { fetchProject } from "state/project";
import DataTable, { parseSortParam } from "components/DataTable";
import { Column } from "react-table-latest";
import { Store } from "interfaces/store";
import { PaginatedQuery } from "interfaces/paginated-query";
import Constants from "helpers/constants";
import { Store2Project } from "interfaces/store2project";

// only load the America/Chicago timezone
moment.tz.load({
  version: "2018g",
  zones: [
    "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  ],
  links: ["America/Chicago|US/Central"],
});

interface MappingPreviewOwnProps {
  prefix: string;
  errorPrefixes?: string[];
  showError?: boolean;
  projectId: string;
}

type MappingPreviewProps = MappingPreviewOwnProps & PropsFromRedux;

class MappingPreview extends React.Component<MappingPreviewProps> {
  private MAPPING_PREVIEW_PAGE_SIZE = 20;
  //See componentDidMount() for the default sorting parameter
  private MAPPING_PREVIEW_DEFAULT_SORT = "";

  private defaultPaginationParams: PaginatedQuery = {
    sort: this.MAPPING_PREVIEW_DEFAULT_SORT,
    size: this.MAPPING_PREVIEW_PAGE_SIZE,
    page: 0,
  };

  public state = { ...this.defaultPaginationParams, initialMountComplete: false};

  public componentDidMount() {
    const { projectId } = this.props;
    return this.props.fetchProject(projectId).then(() => {
      const { project } = this.props;

      const isFileSharing = project?.project_type === Constants.FILE_SHARING;
      const initialSortParam = isFileSharing ? "actual_reset_date.desc" : "store_number.asc";
      this.setState({ ...this.defaultPaginationParams, sort: initialSortParam });
      this.props.fetchStoresByProjectId(projectId, {
        ...this.defaultPaginationParams,
        sort: initialSortParam,
      });
    }).then(()=>{
      //Delays initial render of Stores DataTable until after redux store is properly updated
      //Prevents initialization of DataTable's initalState to stale data from previous pages
      this.setState({ ...this.state, initialMountComplete: true});
    });;
  }

  public componentWillUnmount() {
    const { prefix, errorPrefixes } = this.props;

    this.props.unsetError(prefix);
    if (errorPrefixes) {
      errorPrefixes.forEach((errorPrefix) => this.props.unsetError(errorPrefix));
    }
  }

  public componentDidUpdate(prevProps: MappingPreviewProps, prevState: PaginatedQuery) {
    const { projectId } = this.props;

    // if a new file was being loading
    // and loaded without an error
    // then re-fetch
    // TODO: Is there a better way to do this?
    if (
      (prevProps.upload.loading && !this.props.upload.loading && !this.props.upload.hasError) ||
      (prevProps.errorUpload &&
        prevProps.errorUpload.loading &&
        this.props.errorUpload &&
        !this.props.errorUpload.loading &&
        !this.props.errorUpload.hasError) ||
      prevState.page !== this.state.page ||
      prevState.sort !== this.state.sort ||
      prevState.size !== this.state.size
    ) {
      this.props.fetchStoresByProjectId(projectId, this.state);
    }
  }

  public render() {
    const {
      upload: { hasError: defaultError, errors: defaultErrors = [] },
      errorUpload,
      stores,
      loadingStores,
      showError = true,
      storesPageCount,
      storesPageIndex,
      project,
    } = this.props;

    if (!stores) {
      return null;
    }

    const hasError = defaultError || (errorUpload && errorUpload.hasError);
    const errors: string[] = defaultErrors.concat((errorUpload && errorUpload.errors) || []);
    const isFileSharing = project?.project_type === Constants.FILE_SHARING;

    const tableColumnsConfig = [
      {
        accessor: "store_number",
        Header: "Store No",
        dataQa: "store_number",
      },
      {
        accessor: "store_address",
        Header: "Address",
        dataQa: "address",
      },
      {
        accessor: "store_validation_deadline",
        Header: "Validation Deadline",
        Cell: ({ value }: { value: string }) => {
          return moment(value).tz("America/Chicago").format("M/DD/YYYY");
        },
        dataQa: "validation_deadline",
      },
      {
        show: isFileSharing,
        accessor: "actual_reset_date",
        Header: "Actual Reset Date",
        Cell: ({ value }: { value: string }) => {
          return value ? moment(value).tz("America/Chicago").format("M/DD/YYYY") : "";
        },
        dataQa: "actual_reset_date",
      },
    ] as (Column<Store & Partial<Store2Project>> & { dataQa: string; show: boolean })[];

    //TODO: style={{ maxHeight: "615px" }}
    return (
      <>
        {hasError && (
          <div className="error card-error">
            <img src={errorWhiteSvg} alt="Error Icon" />
            <p className="text">Error: File formatting. See above for details.</p>
          </div>
        )}
        {this.state.initialMountComplete && this.state.sort && (
          <DataTable
            isLoading={loadingStores}
            data={stores}
            renderEmpty={"Upload a project file to see the mapping preview"}
            columns={tableColumnsConfig}
            getRowId={(row) => String(row.store_id)}
            sortable
            paginated
            manualPagination
            pageCount={storesPageCount}
            initialState={{
              pageSize: this.MAPPING_PREVIEW_PAGE_SIZE,
              pageIndex: storesPageIndex,
              sortBy: parseSortParam(this.state.sort),
              hiddenColumns: tableColumnsConfig
                .filter((col: any) => col.show === false)
                .map((col) => col.id || col.accessor) as any,
            }}
            onPageChange={(page: number, size: number, sort: string) => {
              if (
                page !== this.state.page ||
                size !== this.state.size ||
                sort !== this.state.sort
              ) {
                this.setState({ ...this.state, size: size, sort: sort, page: page });
              }
            }}
          />
        )}
        {showError && hasError && (
          <div className="card-error-bottom">
            <h5 className="error">Errors:</h5>
            <ul className="error-list">
              {errors.map((e) => (
                <li key={e}>
                  <Body type="3">{e}</Body>
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  }
}

const connecter = connect(
  (state: State, ownProps: MappingPreviewOwnProps) => {
    const { prefix, errorPrefixes = [] } = ownProps;

    let errorUpload: FileUploadState = { hasError: false };
    errorPrefixes.some((errorPrefix) => {
      // @ts-ignore
      if (state[`${errorPrefix}_file_upload`].hasError) {
        // @ts-ignore
        errorUpload = state[`${errorPrefix}_file_upload`];
        return true;
      }
      return false;
    });

    return {
      errorUpload,
      upload: {
        // @ts-ignore
        ...state[`${prefix}_file_upload`],
        hasError: errorUpload.hasError,
      },
      project: state.project.content,
      stores: state.stores.content?.data,
      storesPageCount: state.stores.content?.pageCount,
      storesPageIndex: state.stores.content?.pageIndex,
      loadingStores: state.stores.loading,
    };
  },
  { fetchStoresByProjectId, fetchProject, unsetError }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(MappingPreview);
